// Helper function to clean HTML content for plain text display
export const cleanHtmlContent = (htmlString) => {
  if (!htmlString) return '';
  
  // Create a temporary DOM element to properly decode HTML entities
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;
  
  // Get the decoded text content
  const decodedText = tempDiv.textContent || tempDiv.innerText || '';
  
  return decodedText
    .replace(/\s+/g, ' ') // Replace multiple spaces with single space
    .trim(); // Remove leading/trailing whitespace
};
